import styled from 'styled-components';

export const StyledPageBack = styled.div`
  font-size: ${props => props.theme.fontSizes.extraSmall};
  margin: 0 0 30px;
  display: flex;
  align-items: center;

  svg {
    font-size: ${props => props.theme.fontSizes.normal};
    position: relative;
    top: 3px;
    margin-right: 10px;
  }
`
